import { render, staticRenderFns } from "./shoppingcart.vue?vue&type=template&id=28dd0845&scoped=true"
import script from "./shoppingcart.vue?vue&type=script&lang=js"
export * from "./shoppingcart.vue?vue&type=script&lang=js"
import style0 from "./shoppingcart.vue?vue&type=style&index=0&id=28dd0845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd0845",
  null
  
)

export default component.exports